import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const ChevronDownIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M17.5 9.25741C17.5 8.14991 16.2658 7.48907 15.3442 8.10324L10 11.6666L4.65583 8.10407C3.73417 7.48991 2.5 8.14991 2.5 9.25741C2.5 9.72074 2.73167 10.1541 3.1175 10.4116L9.07583 14.3832C9.63583 14.7566 10.365 14.7566 10.925 14.3832L16.8833 10.4116C17.2683 10.1541 17.5 9.72157 17.5 9.25741Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

ChevronDownIcon.propTypes = {
  sx: PropTypes.object,
};

export default ChevronDownIcon;
